
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { formatDateWithTime, formatBool } from "@/utils";
import { InventoryItemListItem} from "@/models/api/barcodeSystem/inventory/inventoryItems";
import { LinkInventoryRequest, UnspecifiedItem } from "@/models/api/barcodeSystem/barcodeOrders/linkInventory";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";

const inventoryModule = getModule(InventoryModule)

@Component
export default class BarcodeOrderInventoryLinking extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  linkInventoryRequest: LinkInventoryRequest;

  get filterSpecifiedFields() {
    let filterFields = inventoryModule.itemFields.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterSpecifiedFields(newValue) {
  }

  get filterUnspecifiedFields() {
    let filterFields = inventoryModule.unspecifiedItemFields.filter(
      field => field.hidden === false && field.key !== "selected"
    );
    return filterFields;
  }

  set filterUnspecifiedFields(newValue) {
  }

  get specifiedItems(): Array<InventoryItemListItem> {
    return this.linkInventoryRequest ? this.linkInventoryRequest.specifiedItems : [];
  }

  get unspecifiedItems(): Array<UnspecifiedItem> {
    return this.linkInventoryRequest ? this.linkInventoryRequest.unspecifiedItems : [];
  }

  get crn(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.crn
      : ""; 
  }

  get companyName(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.companyName
      : ""; 
  }

  set companyName(val: string){
  }  
  
  get companyId(): number {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.companyId
      : null; 
  }

  set companyId(val: number){
  }

  get billToCompanyId(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.billToCompanyId
      : "";  
  }

  set billToCompanyId(val: string){
  }

  get orderNumber(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.orderNumber
      : ""; 
  }

  set orderNumber(val: string){
  }  
  
  get deliveryType(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.deliveryType
      : ""; 
  }

  set deliveryType(val: string){
  }

  get status(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.status
      : "";  
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.statusDescription
      : "";  
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get specifiedItemCount() : number
  {
    return this.linkInventoryRequest && this.linkInventoryRequest.specifiedItems
      ? this.linkInventoryRequest.specifiedItems.length
      : 0;
  }

  get unspecifiedItemCount() : number
  {
    return this.linkInventoryRequest && this.linkInventoryRequest.unspecifiedItems
      ? this.linkInventoryRequest.unspecifiedItems.length
      : 0;
  }  
  
  get isLinkingComplete(): boolean {
    return this.linkInventoryRequest
      ? this.linkInventoryRequest.isLinkingComplete
      : false; 
  }

  set isLinkingComplete(val: boolean){
    if(this.linkInventoryRequest)
      this.linkInventoryRequest.isLinkingComplete = val;
  }

  removeSpecifiedItem(item){
    if(this.linkInventoryRequest && this.linkInventoryRequest.specifiedItems){
      var index = this.linkInventoryRequest.specifiedItems.indexOf(item);


      if (index < 0) {
          return;
      }

      this.linkInventoryRequest.specifiedItems.splice(index, 1);
    }
  }

  removeUnspecifiedItem(item){
    if(this.linkInventoryRequest && this.linkInventoryRequest.unspecifiedItems){
      var index = this.linkInventoryRequest.unspecifiedItems.indexOf(item);

      if (index < 0) {
          return;
      }

      this.linkInventoryRequest.unspecifiedItems.splice(index, 1);
    }
  }

  formatDateWithTime(val) {
    return formatDateWithTime(val)
  }

  formatBool(val) {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  canMove() {
    return false;
  }

  getFieldClass(field, itemData) {
    var fieldClass = null;
    if (field.textAlign) {
      switch (field.textAlign) {
        case "right":
          fieldClass = "text-right";
          break;
        case "left":
          fieldClass = "text-left";
          break;
        case "center":
          fieldClass = "text-center";
          break;
        default:
          break;
      }
    }

    if(field.noWrap)
    {
      fieldClass += " text-nowrap";
    }

    return fieldClass;
  }

  getValue(object, path) {
    if (!path) return;
    return path.split(".").reduce((r, k) => (r ? r[k] : ""), object);
  }
}
